<template lang="pug">
    .equal-columns
        .column.left
            perfect-scrollbar
                slot(name="header")
                .main-menu
                    slot(name="menu")
                main.contentpage
                    .section(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
                        Heading(v-if="section.key === 'heading'" :section="section")
                        ImageSection(v-if="section.key === 'image'" :section="section")
                        Post(v-if="section.key === 'post'" :section="section")
                        LoginForm(v-if="section.key === 'login'" :section="section")
        .column.right
            main.addition
                transition(name="slide-left")
                    .slide-container(v-if="showRightPanel")
                        //- button.close-slide-container(v-if="additionalSections.length" @click="showRightPanel = false") X
                        button.close-slide-container(v-if="additionalSections.length" @click="goUp") X
                        perfect-scrollbar
                            .section(v-if="additionalSections.length" v-for="(section, index) in additionalSections" :key="section.id" :class="section.key")
                                ImageSection(v-if="section.key === 'image'" :section="section")
                                PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
                                MapBox(v-if="section.key === 'mapbox'" :section="section")
                                EventCalendar(v-if="section.key === 'events'" :section="section")
            slot(name="footer")
</template>

<script>

import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'

import LoginForm from '@/components/LoginForm'

export default {
    name: 'LoginPage',
    components: {
        Heading,
        ImageSection,
        Post,
        LoginForm,
    },
    data: () => {
        return {
            showRightPanel: false,
        }
    },
    computed: {
        mainSections() {
            return this.sections.filter(section => {
                return section.area === 'main' && (section.key === 'heading' || section.key === 'post' || section.key === 'login')
            })
        },
        additionalSections() {
            return this.sections.filter(section => {
                return section.area === 'right'
                    && (section.key === 'image' || section.key === 'photoalbum'|| section.key === 'mapbox')
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            parent: 'currentPage/parent',
            menus: 'menus',
        }),
    },
    methods: {
        goUp() {
            let parent = this.parent

            const menu = this.menus.find(menu => menu.key === 'main-menu')
            const collection = _.cloneDeep(menu.menuItems);
            while (parent && parent.page && (parent.page.view === 'Folder' || parent.page.view === 'Redirect')) {
                let ancestors = NestedSet.getAncestors(collection, parent) || [];
                if (ancestors && ancestors.length) parent = ancestors[0]
                else parent = undefined
            }

            if (parent) router.push(parent.path)
            else router.push('/')
        },
    },
    mounted() {
        if (window.innerWidth >= 1088 && this.additionalSections.length) {
            setTimeout(() => {
                this.showRightPanel = true
            }, 300)
        } else {
            this.showRightPanel = true
        }
    },
    beforeRouteLeave(to, from, next) {
        if (window.innerWidth >= 1088 && this.additionalSections.length) {
            this.showRightPanel = false
            setTimeout(next, 300)
        } else {
            next()
        }
    }
}

</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins";

    .slide-container
        button.close-slide-container
            display: none
            +desktop
                display: none
</style>
